{{ type() | warehouseRestockType | async }}
